import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../../styles/Dashboard.css';
import Navbar from '../navbar';
import Sidebar from './../sidebar/index';
import Typography from '../../components/Typography';
import CustomModal from '../../components/CustomModal';

const Referral = () => {
  const [user, setUser] = useState(null);
  const [referralSignups, setReferralSignups] = useState([]);
  const [referralLink, setReferralLink] = useState('');
  const navigate = useNavigate();
  const [referralCodeCopied, setReferralCodeCopied] = useState(false);
  const [referralLinkCopied, setReferralLinkCopied] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('success');
  const [modalMessage, setModalMessage] = useState('');
  const [title, setTitle] = useState('');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [referralCode, setReferralCode] = useState('ASH-UNKNOWN');

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };
  useEffect(() => {
    const fetchUserAndReferrals = async () => {
      try {
        const token = localStorage.getItem('token');
        const userResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/auth/dashboard`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(userResponse.data);
        setReferralCode(userResponse.data.referralCode);

        const referralResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/referrals/signups`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setReferralSignups(referralResponse.data.referrals);

        // Check if user already has a referral link
        if (userResponse.data.referralLinks && userResponse.data.referralLinks.length > 0) {
          setReferralLink(`${process.env.REACT_APP_CLIENT_URL}/${userResponse.data.referralLinks[0].path}`);
        } else {
          const referralLinkResponse = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/referrals/generate-link`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
          );
          setReferralLink(referralLinkResponse.data.referralLink);
        }
      } catch (error) {
        localStorage.removeItem('token');
        navigate('/');
      }
    };
    fetchUserAndReferrals();
  }, [navigate]);



  const handleCopied = async () => {
    setTitle('Referral copied!');
    setModalType('success');
    setModalMessage('Share it with friends or your network to earn rewards from the Ash Capital team');
    setShowModal(true);
  };

  const handleReferralCodeCopy = async () => {
    try {
      await navigator.clipboard.writeText(referralCode);
      setReferralCodeCopied(true);
      // await handleCopied();
      setTimeout(() => {
        setReferralCodeCopied(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to copy!', err);
    }
  };

  const handleReferralLinkCopy = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      setReferralLinkCopied(true);
      // await handleCopied();
      setTimeout(() => {
        setReferralLinkCopied(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to copy!', err);
    }
  };

  const handleShare = async (email) => {
    await navigator.clipboard.writeText(referralLink);
    await handleCopied();

    // try {
    //   console.log(`Sharing referral link with ${email}`);
    //   setTitle('Referral Shared!');
    //   setModalType('success');
    //   setModalMessage(`Referral link sent to ${email}`);
    //   setShowModal(true);
    // } catch (err) {
    //   console.error('Failed to share!', err);
    //   setTitle('Error');
    //   setModalType('error');
    //   setModalMessage('Failed to share referral link');
    //   setShowModal(true);
    // }
  };

  return (
    <div>
      <Navbar user={user} isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        closeSidebar={closeSidebar} />
      <div className="flex"  >
        <Sidebar isOpen={isSidebarOpen} closeSidebar={closeSidebar} />
        {showModal && (
          <CustomModal
            type={modalType}
            title={title}
            message={modalMessage}
            onClose={() => setShowModal(false)}
          />
        )}
        <div className="w-full h-full min-h-screen sm:p-5 bg-[#121212] border-[#353535] border-l">
          <div className='grid sm:grid-cols-2 grid-cols-1 gap-3'>
            <div className='col-span-1 rounded-[4px] bg-black px-5 py-6'>
              <Typography text={'referral program'} size={'16px'} family={'Supply'} color={'#FFF'} transform={'uppercase'} weight={400} />
              <div className='flex'><Typography className='' text={'Referral Fee '} size={'25px'} family={'Supply'} lineheight={'55.929px'} weight={300} color={'#616161'} transform={'uppercase'} />  <Typography transform={'uppercase'} family={'Supply'} className='' text={'2%'} size={'25px'} lineheight={'55.929px'} weight={700} color={'#DF0F11'} /> </div>
              <Typography className='' text={'Diversified High Yield'} size={'13px'} lineheight={'27px'} weight={400} letterspacing={'-0.39px'} transform={'uppercase'} family={'Supply'} color={'#DF0F11'} />
              <Typography className='' text={'2% Referral Fee'} size={'13px'} lineheight={'27px'} weight={400} letterspacing={'-0.39px'} transform={'uppercase'} family={'Supply'} color={'#FFFFFF'} />
              <ul className='text-white list-disc px-5'>
                <li><Typography className='' text={'Earn a one-time referral reward for each new investor referred.'} size={'13px'} lineheight={'27px'} weight={400} letterspacing={'-0.39px'} transform={'uppercase'} family={'Supply'} color={'#FFFFFF'} /></li>
                <li><Typography className='' text={'Rewards are based on the principal amount of the referred investment.'} size={'13px'} lineheight={'27px'} weight={400} letterspacing={'-0.39px'} transform={'uppercase'} family={'Supply'} color={'#FFFFFF'} /></li>
                <li><Typography className='' text={'Paid after 90 days of investment effective date in a single payout.'} size={'13px'} lineheight={'27px'} weight={400} letterspacing={'-0.39px'} transform={'uppercase'} family={'Supply'} color={'#FFFFFF'} /></li>
              </ul>
            </div>
            <div className='col-span-1 rounded-[4px] bg-black px-5 py-6'>
              <Typography text={'Progressive '} size={'16px'} family={'Supply'} color={'#FFF'} transform={'uppercase'} weight={400} />
              <div className='flex'><Typography className='' text={'Referral Fee '} size={'25px'} family={'Supply'} lineheight={'55.929px'} weight={300} color={'#616161'} transform={'uppercase'} />  <Typography transform={'uppercase'} family={'Supply'} className='' text={'4%'} size={'25px'} lineheight={'55.929px'} weight={700} color={'#DF0F11'} /> </div>
              <Typography className='' text={'Progressive Equity Backed / Fixed Equity Backed'} size={'13px'} lineheight={'27px'} weight={400} letterspacing={'-0.39px'} transform={'uppercase'} family={'Supply'} color={'#DF0F11'} />
              <Typography className='' text={'4% Referral Fee'} size={'13px'} lineheight={'27px'} weight={400} letterspacing={'-0.39px'} transform={'uppercase'} family={'Supply'} color={'#FFFFFF'} />
              <ul className='text-white list-disc px-5'>
                <li><Typography className='' text={'Receive quarterly referral rewards over the first year.'} size={'13px'} lineheight={'27px'} weight={400} letterspacing={'-0.39px'} transform={'uppercase'} family={'Supply'} color={'#FFFFFF'} /></li>
                <li><Typography className='' text={'Rewards are based on the principal amount of the referred investment.'} size={'13px'} lineheight={'27px'} weight={400} letterspacing={'-0.39px'} transform={'uppercase'} family={'Supply'} color={'#FFFFFF'} /></li>
                <li><Typography className='' text={'Referral fee is distributed in four equal installments of 1%.'} size={'13px'} lineheight={'27px'} weight={400} letterspacing={'-0.39px'} transform={'uppercase'} family={'Supply'} color={'#FFFFFF'} /></li>
              </ul>
            </div>
          </div>
          <div className='grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5 mt-5'>
            <div className='col-span-1 rounded-[4px] bg-black px-5 py-6'>
              <Typography text={'referral CODE '} size={'16px'} family={'Supply'} color={'#FFF'} transform={'uppercase'} weight={400} />
              <div className={`flex py-2 items-center w-full mt-[37px] border-t border-[#151515] border-b`}>
                <div className='w-[3px] h-[24px] bg-[#DF0F11]'></div>
                <div className='flex justify-between w-full items-center'>
                  <Typography color={'#FFF'} className='ml-[7px]' size={'14px'} family={'Supply'} weight={400} text={referralCode} transform={'uppercase'} />
                  <button onClick={handleReferralCodeCopy} className='inline-flex justify-center items-center gap-2 border-[0.687px] border-[#FFF]' style={{ padding: '5px 20.522px 3.522px 21px' }} >
                    <Typography color={'#FFF'} className='ml-[7px]' size={'14px'} family={'Supply'} weight={400} text={referralCodeCopied ? 'Copied!' : 'Copy'} transform={'uppercase'} lineheight={'170%'} />
                    {!referralCodeCopied && <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                      <path d="M5.49245 10.9851V12.9075C5.49245 13.6765 5.49245 14.061 5.64211 14.3547C5.77376 14.6131 5.98382 14.8232 6.24219 14.9548C6.53592 15.1045 6.92044 15.1045 7.68946 15.1045H12.9074C13.6764 15.1045 14.0609 15.1045 14.3546 14.9548C14.613 14.8232 14.8231 14.6131 14.9547 14.3547C15.1044 14.061 15.1044 13.6765 15.1044 12.9075V7.68955C15.1044 6.92052 15.1044 6.53601 14.9547 6.24228C14.8231 5.98391 14.613 5.77384 14.3546 5.6422C14.0609 5.49253 13.6764 5.49253 12.9074 5.49253H10.985M3.57006 10.9851H8.78797C9.557 10.9851 9.94151 10.9851 10.2352 10.8354C10.4936 10.7038 10.7037 10.4937 10.8353 10.2353C10.985 9.9416 10.985 9.55708 10.985 8.78806V3.57015C10.985 2.80112 10.985 2.4166 10.8353 2.12288C10.7037 1.8645 10.4936 1.65444 10.2352 1.52279C9.94151 1.37313 9.557 1.37313 8.78797 1.37313H3.57006C2.80103 1.37313 2.41652 1.37313 2.12279 1.52279C1.86442 1.65444 1.65436 1.8645 1.52271 2.12288C1.37305 2.4166 1.37305 2.80112 1.37305 3.57015V8.78806C1.37305 9.55708 1.37305 9.9416 1.52271 10.2353C1.65436 10.4937 1.86442 10.7038 2.12279 10.8354C2.41652 10.9851 2.80103 10.9851 3.57006 10.9851Z" stroke="#DF0F11" strokeWidth="1.37313" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>}
                  </button>
                </div>
              </div>
            </div>
            <div className='lg:col-span-2 col-span-1 rounded-[4px] bg-black px-5 py-6'>
              <Typography text={'referral LINK '} size={'16px'} family={'Supply'} color={'#FFF'} transform={'uppercase'} weight={400} />
              <div className={`flex py-2  items-center mt-[37px] border-t border-[#151515] border-b`}>
                <div className='w-[3px] h-[24px] bg-[#DF0F11]'></div>
                <div className='flex relative w-full justify-between self-stretch gap-2 items-center'>
                    <Typography color={'#FFF'} className='ml-[7px] text-sm lg:text-base truncate lg:whitespace-normal lg:overflow-visible lg:text-clip max-w-[200px] lg:max-w-none' size={'14px'} family={'Supply'} weight={400} text={referralLink || 'Loading...'} transform={'uppercase'} />
                  <button onClick={handleReferralLinkCopy} className='inline-flex justify-center items-center gap-2 border-[0.687px] border-[#FFF]' style={{ padding: '5px 20.522px 3.522px 21px' }} >
                    <Typography color={'#FFF'} className='ml-[7px]' size={'14px'} family={'Supply'} weight={400} text={referralLinkCopied ? 'Copied!' : 'Copy'} transform={'uppercase'} lineheight={'170%'} />
                    {!referralLinkCopied && <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                      <path d="M5.49245 10.9851V12.9075C5.49245 13.6765 5.49245 14.061 5.64211 14.3547C5.77376 14.6131 5.98382 14.8232 6.24219 14.9548C6.53592 15.1045 6.92044 15.1045 7.68946 15.1045H12.9074C13.6764 15.1045 14.0609 15.1045 14.3546 14.9548C14.613 14.8232 14.8231 14.6131 14.9547 14.3547C15.1044 14.061 15.1044 13.6765 15.1044 12.9075V7.68955C15.1044 6.92052 15.1044 6.53601 14.9547 6.24228C14.8231 5.98391 14.613 5.77384 14.3546 5.6422C14.0609 5.49253 13.6764 5.49253 12.9074 5.49253H10.985M3.57006 10.9851H8.78797C9.557 10.9851 9.94151 10.9851 10.2352 10.8354C10.4936 10.7038 10.7037 10.4937 10.8353 10.2353C10.985 9.9416 10.985 9.55708 10.985 8.78806V3.57015C10.985 2.80112 10.985 2.4166 10.8353 2.12288C10.7037 1.8645 10.4936 1.65444 10.2352 1.52279C9.94151 1.37313 9.557 1.37313 8.78797 1.37313H3.57006C2.80103 1.37313 2.41652 1.37313 2.12279 1.52279C1.86442 1.65444 1.65436 1.8645 1.52271 2.12288C1.37305 2.4166 1.37305 2.80112 1.37305 3.57015V8.78806C1.37305 9.55708 1.37305 9.9416 1.52271 10.2353C1.65436 10.4937 1.86442 10.7038 2.12279 10.8354C2.41652 10.9851 2.80103 10.9851 3.57006 10.9851Z" stroke="#DF0F11" strokeWidth="1.37313" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className='w-full rounded-[4px] mt-[15px] bg-black p-6'>
            <Typography text={'Referral Signups'} size={'16px'} family={'Supply'} color={'#FFF'} transform={'uppercase'} weight={400} />
            {/* <div className="relative">
              <table className="w-full text-sm text-left rtl:text-right table-fixed">
                <thead className="text-xs text-white opacity-60">
                  <tr className="border-b border-[#151515]">
                    {['Name', 'Date', 'Email', 'Code', ''].map((heading, index) => (
                      <th key={index} scope="col" className="px-6 py-3">
                        {heading && <Typography text={heading} size={'14px'} weight={400} />}
                      </th>
                    ))}
                  </tr>
                </thead>
              </table>
            </div> */}
            <div className="relative h-52 scrollbar-hide scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-transparent overflow-y-auto overflow-x-auto" >
              <table className="w-full text-sm text-left rtl:text-right">
                <thead className="text-xs text-white opacity-60">
                  <tr className="border-b border-[#151515]">
                    {['Name', 'Date', 'Email', 'Code', ''].map((heading, index) => (
                      <th key={index} scope="col" className="lg:px-6 px-2 py-3">
                        {heading && <Typography text={heading} size={'14px'} weight={400} />}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="overflow-y-auto">
                  {referralSignups.map((row, idx) => (
                    <tr key={idx} className="border-b py-4 border-[#151515] h-[50px] text-white">
                      <td className="lg:px-6 px-2">
                        <Typography text={row.name} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-2">
                        <Typography text={row.date} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-2">
                        <Typography text={row.email} size={'14px'} weight={400} />
                      </td>
                      <td className="lg:px-6 px-2">
                        <Typography text={row.code} size={'14px'} weight={400} />
                      </td>
                      <td className="text-center lg:px-6 px-2 ">
                        <button onClick={() => handleShare(row.email)} className="flex mx-auto items-center justify-center rounded-sm px-[18px] py-[10px] h-7 border-[#FFF] border-[1px]">
                          <Typography text="Share" color="#FFF" opacity="0.6" size="12px" weight={400} lineheight="170%" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Referral;